import { getCorrectStrTime } from './getCorrectStrTime';

export const addMinuteSecond = (hour: number) => `${getCorrectStrTime(hour)}:00:00`;
